import { EncounterDetailModel } from 'src/app/api/proxy/practice/practice-models';
import { TreatmentService } from 'src/app/services/treatment-service/treatment.service';

/**
 * True when reopening a queue row with no linked encounterId should resume the local
 * CurrentEncounter draft (same queue id, savable in-progress work).
 */
export function shouldResumeUnlinkedQueuedDraft(options: {
  queuedTreatmentId?: string | null;
  cachedQueuedTreatmentId?: string | null;
  draftEncounter?: EncounterDetailModel | null;
}): boolean {
  const openQueueId = options.queuedTreatmentId?.trim();
  if (!openQueueId) {
    return false;
  }
  if (options.cachedQueuedTreatmentId !== openQueueId) {
    return false;
  }
  return TreatmentService.shouldKeepCurrentEncounter(options.draftEncounter);
}
